import { useFetch } from '../context';
import { useSnackbarContext } from '../context/SnackbarProvider';
import CopyLinkSnackBar from '../Snackbar/CopyLinkSnackBar';
import { useCopyToClipboard } from './useCopyToClipboard';

type CreateDeepLinkArgs = {
  scheduleID?: number;
  playlistID?: number;
  learnNodeID?: number;
  url: string;
};

/**
 * Creates a deep link, copies it to clipboard, and shows a snackbar.
 */
export function useCreateDeepLink() {
  const { post } = useFetch();
  const { copy: copyToClipboard } = useCopyToClipboard();
  const { onAddSnackBar } = useSnackbarContext();

  const createDeepLink = async ({
    scheduleID,
    playlistID,
    learnNodeID,
    url,
  }: CreateDeepLinkArgs): Promise<string | null> => {
    if (!url) return null;

    const { data } = await post<
      { deep_link_uri: string },
      Record<string, unknown>
    >('/create-deeplink', {
      url,
      scheduleID,
      playlistID,
      learnNodeID,
    });

    copyToClipboard(data.deep_link_uri);
    onAddSnackBar({
      message: <CopyLinkSnackBar link={data.deep_link_uri} />,
      variant: 'positive',
    });

    return data.deep_link_uri;
  };

  return { createDeepLink };
}
